function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null);

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#484848",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M15.129 4.991v9.399c0 .617-.492 1.14-1.074 1.14H3.587c-.582 0-1.074-.523-1.074-1.14V4.991M.858 5.56L9.045 1.29"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#484848",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M7.076 15.197V8.74c0-.474.358-.854.806-.854h2.192c.447 0 .805.38.805.854v6.456M9.134 1.289l8.053 4.7"
});

function SvgRemote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 18 17"
  }, props), _ref, _ref2, _ref3);
}

export default SvgRemote;